import { SINGLE_NUMERIC } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const room: EffectEntry = {
  kind: 'room',
  category: 'effect',
  family: 'space',
  doc: 'reverb wet amount (0 dry, 0.3 hint, 0.8 cathedral)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('room', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('room', 'fromAst'),
};

export const roomsize: EffectEntry = {
  kind: 'roomsize',
  category: 'effect',
  family: 'space',
  doc: 'reverb tail size in virtual metres',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('roomsize', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('roomsize', 'fromAst'),
};

export const size: EffectEntry = {
  kind: 'size',
  category: 'effect',
  family: 'space',
  doc: 'alias for roomsize on some builds',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('size', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('size', 'fromAst'),
};

export const predelay: EffectEntry = {
  kind: 'predelay',
  category: 'effect',
  family: 'space',
  doc: 'reverb predelay in ms',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('predelay', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('predelay', 'fromAst'),
};

export const dry: EffectEntry = {
  kind: 'dry',
  category: 'effect',
  family: 'space',
  doc: 'dry-path gain (compensate for heavy reverb)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('dry', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('dry', 'fromAst'),
};
